/* LUVEA — raccourcis de filtre (.scroll-button) rendus CONTEXTUELS (V16).

   Constat d'audit : la rangee « ARGENT / PLAQUE OR / OR ROSE / PERLES… » des
   pages collection/recherche n'est pas dans le theme — elle est injectee par
   Searchanise (HTML configure dans l'app). Ses liens sont ECRITS EN DUR vers
   une collection fixe : depuis /collections/promos, taper ARGENT envoyait vers
   /collections/colliers?rb_tags=Argent — on PERDAIT le contexte.

   Ce script reecrit chaque raccourci porteur d'un rb_tags pour rester dans la
   collection COURANTE : /collections/promos + ARGENT -> /collections/promos
   ?rb_tags=Argent. Les liens sans rb_tags (« Toutes les bagues »,
   « Personnalise » vers une collection) ne sont pas touches. Sur une vraie
   page de recherche (/search), on ne touche a rien : il n'y a pas de contexte
   de collection a garder.

   Tags verifies cote boutique (21/07) : Argent, Plaque Or, Plaque Or Rose,
   Perles, Lumina, Personnalise existent tous — aucun raccourci ne pointe dans
   le vide.

   Bonus : le raccourci correspondant au filtre ACTIF (rb_tags courant) est
   souligne plus fort — la cliente voit ou elle est. */
(function () {
  function tagDe(href) {
    var m = String(href || '').match(/[?&]rb_tags=([^&]+)/);
    return m ? m[1] : null;
  }
  function passe() {
    var chemin = window.location.pathname;
    if (!/^\/collections\/[^\/]+/.test(chemin)) { return; }
    var base = chemin.replace(/\/$/, '');
    var actif = tagDe(window.location.search ? '?' + window.location.search.slice(1) : '');
    var liens = document.querySelectorAll('a.scroll-button');
    for (var i = 0; i < liens.length; i++) {
      var a = liens[i];
      var tag = tagDe(a.getAttribute('href'));
      if (!tag) { continue; }                       /* lien sans rb_tags : on laisse */
      if (!a.dataset.lvCtx) {
        a.setAttribute('href', base + '?rb_tags=' + tag);
        a.dataset.lvCtx = '1';
      }
      /* Filtre actif : trait plus marque. setProperty+important : le style des
         pilules est en !important dans lv-home-clean-2.css. */
      if (actif && decodeURIComponent(tag) === decodeURIComponent(actif) && !a.dataset.lvOn) {
        a.style.setProperty('font-weight', '700', 'important');
        a.style.setProperty('border-bottom-width', '2px', 'important');
        a.dataset.lvOn = '1';
      }
    }
  }
  /* Searchanise peut injecter la rangee apres le chargement : passes bornees. */
  var n = 0;
  var h = setInterval(function () { passe(); if (++n > 20) { clearInterval(h); } }, 500);
  if (document.readyState !== 'loading') { passe(); }
  else { document.addEventListener('DOMContentLoaded', passe); }
})();
